if (!customElements.get('boa-purchase-summary')) {
  customElements.define('boa-purchase-summary', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.prices = JSON.parse(this.querySelector('[data-boa-prices]').textContent);
      this.root = this.closest('.boa-details-layout');
      this.formatter = new Intl.NumberFormat(this.dataset.locale, { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' });
      this.update = this.update.bind(this);
      this.root.addEventListener('input', this.update);
      this.root.addEventListener('change', this.update);
      this.observer = new MutationObserver(records => {
        if (records.some(record => record.target.closest?.('#bcpo') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.('#bcpo') || node.querySelector?.('#bcpo'))))) this.update();
      });
      this.observer.observe(this.root, { childList: true, subtree: true });
      this.update();
    }
    disconnectedCallback() {
      this.root?.removeEventListener('input', this.update);
      this.root?.removeEventListener('change', this.update);
      this.observer?.disconnect();
      this.ready = false;
    }
    update() {
      const form = document.getElementById(this.dataset.formId);
      const quantityInput = this.root.querySelector('.quantity-selector__input');
      const quantity = Math.max(1, Number(quantityInput?.value) || 1);
      const engraving = Array.from(this.root.querySelectorAll('#bcpo input[name="properties[Engraving][]"], #bcpo input[name="properties[Engraving]"]')).some(input => !input.disabled && input.checked && input.value === 'Add engraving');
      const serration = this.root.querySelector('#bcpo select[name="properties[Serration]"]:not([disabled])')?.value || '';
      let additions = 0;
      let known = !form?.querySelector('[name="id"]') || Number(form.querySelector('[name="id"]').value) === this.prices.variant;
      if (engraving) {
        if (typeof this.prices.engraving === 'number') additions += this.prices.engraving;
        else known = false;
      }
      if (serration && serration !== 'No additional serration') {
        if (typeof this.prices.serration[serration] === 'number') additions += this.prices.serration[serration];
        else known = false;
      }
      const money = cents => this.formatter.format(cents / 100);
      const values = { base: money(this.prices.base * quantity), additions: known ? money(additions * quantity) : this.dataset.pending, total: known ? money((this.prices.base + additions) * quantity) : this.dataset.pending };
      Object.entries(values).forEach(([key, value]) => {
        const output = this.querySelector('[data-boa-' + key + ']');
        if (output.textContent !== value) output.textContent = value;
      });
    }
  });
}
